// extracted by mini-css-extract-plugin
export default {"announcementWrapper":"Announcement_announcementWrapper__ZWJh-","announcement":"Announcement_announcement__bmmJA"};